import Button from 'components/Form/Button';
import BasicTable from 'components/Form/Table';
import Toggle from 'components/Form/Toggle';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import {
  useHistory,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { ReadOne } from 'services/financing-proposals';
import { Icon, StatusContent, Title } from 'ui/styled';
import { exposeStrapiError, selectColors } from 'utils';
import { parseCurrency } from 'utils/parsers';
import { formatadores, normalizeName } from 'utils/validators';
import {
  FinancingProposalFormsWrapper,
  FinancingProposalHeader,
  FormSpacing,
} from './styled';

export default function FinancingTableDetails() {
  const history = useHistory();
  const { filterExpression } = useContext(CoreContext);
  const { id, origem } = useParams();
  const { setModal } = useContext(CoreContext);
  const [registers, setRegisters] = useState([]);
  const navigate = (to) => history.push(`/${to}`);
  const handleClickEspelho = () => navigate(`proposals/financing/${id}`);
  const init = useCallback(async () => {
    if (!id) return;
    const result = await ReadOne(id);
    if (result && !exposeStrapiError(result)) {
      setRegisters(result);
    }
  }, [id]);

  useEffect(() => init(), [init]);

  const columns = useMemo(
    () => [
      {
        title: 'Data',
        ref: 'date',
        renderCell: ({ row }) => formatadores.TIMESTAMP_TO_BR(row.date) || '--',
      },
      { title: 'Banco', ref: 'financial' },
      { title: 'Valor Financiado', ref: 'valor_financiamento' },
      { title: 'Entrada', ref: 'valor_entrada' },
      { title: 'Prazo', ref: 'deadline' },
      { title: 'PMT', ref: 'installment_value' },
      {
        title: '1º Vencimento',
        ref: 'data',
        renderCell: ({ row }) => formatadores.TIMESTAMP_TO_BR(row.data) || '--',
      },
      {
        title: 'TAG',
        ref: 'status',
        renderCell: ({ row }) => (
          <StatusContent color={selectColors(row?.status)}>
            {normalizeName(row?.status)}
          </StatusContent>
        ),
      },
      ...(origem !== 'curadoria'
        ? [
            {
              title: 'Aceito',
              ref: 'aceito',
              renderCell: ({ row }) => (
                <Toggle
                  onChange={() => {
                    if (row.status !== 'aprovado') {
                      toast.error(
                        'Somente propostas aprovadas podem ser aceitas'
                      );
                      return;
                    }
                    setModal({
                      type: 'sample',
                      origem: 'proposta',
                      banco: row,
                      id: id,
                      row,
                      reload: () => init(),
                    });
                  }}
                  checked={row.aceito}
                  label=""
                  active={true}
                  value={true}
                />
              ),
            },
          ]
        : []),
      {
        title: '',
        renderCell: ({ row }) => (
          <Icon
            icon="arrow-right"
            pointer
            onClick={() => {
              if (
                origem !== 'curadoria' &&
                row.status.toLowerCase() === 'recusado'
              ) {
                toast.error(
                  'Propostas recusadas só podem ser alteradas em Curadoria'
                );
                return;
              }
              setModal({
                type: 'add-proposal',
                banco: row,
                id: id,
                row,
                reload: () => init(),
              });
            }}
          />
        ),
      },
    ],
    [id, setModal, init, origem]
  );
  const rows = useMemo(
    () =>
      registers.propostas_banco
        ?.filter(
          (r) =>
            r.status?.toLowerCase() === 'em analise' ||
            r.status?.toLowerCase() === 'aprovado' ||
            r.status?.toLowerCase() === 'recusado'
        )
        ?.map((m) => ({
          id: m?.id,
          date: registers.createdAt || '--',
          financial: normalizeName(m?.banco?.nome_fantasia) || '--',
          data: m?.data,
          deadline: m?.prazo_financiamento || '--',
          installment_value: parseCurrency(m?.valor_parcelas) || '--',
          status: m?.status || '--',
          valor_financiamento: parseCurrency(m?.valor_financiamento) || '--',
          valor_entrada: parseCurrency(m?.valor_entrada) || '--',
          aceito: m?.aceito,
        })) || [],
    [registers]
  );

  return (
    <ContainerAuthenticated>
      <Title>Proposta de financiamento</Title>
      <FinancingProposalFormsWrapper>
        <FormSpacing />
        <FinancingProposalHeader
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Title small nomargin>
            Bancos Recomendados
          </Title>
          <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
            <Button
              color="blue"
              width={'fit-content'}
              small
              nospace
              onClick={() => history.goBack()}
            >
              Voltar
            </Button>
            <Button
              color="green"
              width={'fit-content'}
              small
              nospace
              onClick={handleClickEspelho}
            >
              Gerar Espelho PDF
            </Button>
          </div>
        </FinancingProposalHeader>
        <BasicTable columns={columns} rows={rows?.filter(filterExpression)} />
        <FormSpacing />
      </FinancingProposalFormsWrapper>
    </ContainerAuthenticated>
  );
}
